/**
 * Linha de realidade do PCP (plano 4.3): quanto os compromissos da planilha
 * até o mês M pesam sobre a capacidade até M. Pelos compromissos a fábrica
 * vive acima de 100% (101% a 331% em 12 testes), mas "100 ÷ esse %" previu a
 * fração do que tinha entrega até M que de fato saiu até M, com erro médio
 * de 14 pontos. Sem cor: é leitura para o PCP, não semáforo.
 */
import { contarDiasUteis, fimDoMes, inicioDoMes } from "./calendario";
import { ordenarFila } from "./fila";

export const ERRO_MEDIO_REALIDADE_PONTOS = 14;

const MESES = [
  "janeiro", "fevereiro", "março", "abril", "maio", "junho",
  "julho", "agosto", "setembro", "outubro", "novembro", "dezembro",
];

export function nomeDoMes(iso) {
  return MESES[Number(iso.slice(5, 7)) - 1];
}

/**
 * `linhaDeRealidade({abertos, ritmo, naoUteis, hoje, mes})`, com `mes` =
 * qualquer dia do mês M (M ≥ mês corrente). Retorna `{mes, compromissos,
 * capacidade, pct, fracao, texto}` (pct e fracao em % inteiros) ou `null`
 * sem ritmo, para mês passado ou sem dia útil até o fim do mês.
 */
export function linhaDeRealidade({ abertos, ritmo, naoUteis, hoje, mes } = {}) {
  if (!ritmo || inicioDoMes(mes) < inicioDoMes(hoje)) return null;
  const fim = fimDoMes(mes);
  // Inclui os atrasados (entrega já vencida): continuam sendo compromisso.
  const compromissos = ordenarFila(abertos).filter((item) => item.entrega && item.entrega <= fim).length;
  const capacidade = ritmo * contarDiasUteis(hoje, fim, naoUteis);
  if (capacidade <= 0) return null;
  const pct = Math.round((100 * compromissos) / capacidade);
  const fracao = compromissos > 0 ? Math.round(100 * Math.min(1, capacidade / compromissos)) : 100;
  const nome = nomeDoMes(mes);
  return {
    mes: inicioDoMes(mes),
    compromissos,
    capacidade,
    pct,
    fracao,
    texto:
      `Compromissos da planilha até ${nome}: ${pct}% · cerca de ${fracao}% do que tem entrega até ` +
      `${nome} deve sair até lá (erro medido de ${ERRO_MEDIO_REALIDADE_PONTOS} pontos)`,
  };
}
